import { io, type Socket } from 'socket.io-client';
import { Chat } from './chat.namespace';

export const chatSocket: Socket<Chat.ServerEvents, Chat.ClientEvents> = io(
    `${ENV.serverBaseUrl}${Chat.NAMESPACE}`,
    {
        autoConnect: false,
        withCredentials: true,
        transports: ['websocket', 'polling'],
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
    },
);
